import React from 'react';
import { useFrame } from '@react-three/fiber';
import { Box } from '@react-three/drei';

const Room = ({ dimensions }) => {
  const { length, width, height } = dimensions;
  const wallThickness = 0.1;

  return (
    <group>
      {/* 地板 */}
      <Box
        args={[length, wallThickness, width]}
        position={[0, 0, 0]}
        receiveShadow
      >
        <meshStandardMaterial color="#8B7355" />
      </Box>

      {/* 天花板 - 透明 */}
      <Box
        args={[length, wallThickness, width]}
        position={[0, height, 0]}
        receiveShadow
      >
        <meshStandardMaterial 
          color="#F5F5DC" 
          transparent 
          opacity={0.1}
        />
      </Box>

      {/* 后墙 - 半透明 */}
      <Box
        args={[length, height, wallThickness]}
        position={[0, height / 2, -width / 2]}
        receiveShadow
      >
        <meshStandardMaterial 
          color="#E6E6FA" 
          transparent 
          opacity={0.3}
        />
      </Box>

      {/* 前墙 - 半透明 */}
      <Box
        args={[length, height, wallThickness]}
        position={[0, height / 2, width / 2]}
        receiveShadow
      >
        <meshStandardMaterial 
          color="#E6E6FA" 
          transparent 
          opacity={0.3}
        />
      </Box>

      {/* 左墙 - 半透明 */}
      <Box
        args={[wallThickness, height, width]}
        position={[-length / 2, height / 2, 0]}
        receiveShadow
      >
        <meshStandardMaterial 
          color="#E6E6FA" 
          transparent 
          opacity={0.3}
        />
      </Box>

      {/* 右墙 - 半透明 */}
      <Box
        args={[wallThickness, height, width]}
        position={[length / 2, height / 2, 0]}
        receiveShadow
      >
        <meshStandardMaterial 
          color="#E6E6FA" 
          transparent 
          opacity={0.3}
        />
      </Box>
    </group>
  );
};

export default Room; 